import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { AbstractControl, UntypedFormGroup } from '@angular/forms';

import { Address, RiskModel } from '@amfam/policy/models';
import { CopyService } from '@amfam/shared/utility/shared-services';

import { AddressCompare } from '../../../shared/sorting/address.compare';

@Component({
  selector: 'app-kyd-new-address',
  templateUrl: './kyd-new-address.component.html',
  styleUrls: ['./kyd-new-address.component.scss'],
  standalone: false
})
export class KydNewAddressComponent implements OnInit, OnChanges {
  @Input() shipTos: Address[];
  @Input() public riskGroup: UntypedFormGroup;
  @Input() risk: RiskModel;
  @Output() customAddress = new EventEmitter<Address>();

  public newAddressForm: UntypedFormGroup;
  public address: Address;
  public states: Array<{ name: string; value: string }>;
  public hasDuplicateAddress: boolean;

  private addressLine1Input: AbstractControl;
  private addressLine2Input: AbstractControl;
  private cityInput: AbstractControl;
  private stateInput: AbstractControl;
  private zipcodeInput: AbstractControl;

  constructor(private copyService: CopyService) {}

  ngOnInit() {
    this.states = this.copyService.get('shared', 'usStates');
    this.newAddressForm = <UntypedFormGroup>this.riskGroup.controls['newAddress'];
    this.hasDuplicateAddress = false;
  }

  ngOnChanges() {
    this.address = new Address();
    this.hasDuplicateAddress = false;
    if (this.newAddressForm) {
      this.addressLine1Input = this.newAddressForm.controls['addressLine1Input'];
      this.addressLine2Input = this.newAddressForm.controls['addressLine2Input'];
      this.cityInput = this.newAddressForm.controls['cityInput'];
      this.stateInput = this.newAddressForm.controls['stateInput'];
      this.zipcodeInput = this.newAddressForm.controls['zipcodeInput'];

      this.address.addressLine1 = this.addressLine1Input.value;
      this.address.addressLine2 = this.addressLine2Input.value;
      this.address.city = this.cityInput.value;
      this.address.state = this.stateInput.value;
      this.address.zipCode = this.zipcodeInput.value;
    }
  }

  public hasDuplicate(address) {
    return this.shipTos.some(shipToAddress => AddressCompare.compare(shipToAddress, address) === 0);
  }

  public addAddress() {
    if (this.hasDuplicate(this.address)) {
      this.hasDuplicateAddress = true;
    } else {
      this.hasDuplicateAddress = false;
      // getting copy since reset for will reset the reference (this.address) aswell
      const address = Object.assign({}, this.address);
      this.customAddress.emit(address);
      this.newAddressForm.reset();
    }
  }
}
